module.exports = __webpack_public_path__ + "img/russian.82fa030e.svg";